import { Divider } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { MENU_ITEM_STYLE } from './menu.model';

const useStyles = makeStyles()((theme) => ({
  root: {
    marginTop: theme.spacing(MENU_ITEM_STYLE.PADDING_Y),
    marginBottom: theme.spacing(MENU_ITEM_STYLE.PADDING_Y),
    '& + &, &:not(:first-of-type):not(:has(~ :not(&)))': {
      display: 'none', // hide consecutive dividers. SNEAKY SNEK!
    },
  },
}));

export const MenuDivider: React.FC = () => {
  const { classes } = useStyles();
  return <Divider className={classes.root} />;
};
MenuDivider.displayName = 'MenuDivider';
